/** @format */

import React from "react";
import Footer from "./Footer";
import SyndicationHeader from "./SyndicationHeader";
import EarlyMarkets from "./early-market/EarlyMarkets";
import PreviousSession from "./PreviousSession";
import MarketOverview from "./MarketOverview";
import AdvertisementBanner from "./AdvertisementBanner";
import OutsideMarkets from "./OutsideMarkets";
import Weather from "./Weather";
import EconomicIndicators from "./EconomicIndicators";
import moment from "moment";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import service from "../../utils/service";
import __service from "./service/service";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Message } from "primereact/message";
import { ConditionalWrapper } from "../../utils/common";
import { BUSINESS_UNIT } from "../../utils/PreviousSession.constants";
import { REGIONS, SECTIONS_TITLE, REGION_LABELS } from "./constants/constants";
import {
  isEarlyMarketEmpty,
  isPreviousEmpty,
  isMarketOverviewEmpty,
  isOutSideMarketEmpty,
  isWeatherEmpty,
} from "./utils/utils";
export default class Syndication extends React.Component {
  constructor() {
    super();
    this.state = {
      region: REGIONS.EMEA,
      selectedDate: new Date(),
      publish: false,
      prePublish: false,
      sectionData: {},
      earlyMarket: {},
      marketOverview: {},
      outsideMarkets: {},
      previous: {},
      syndicationAdvertisementBanner: {},
      weather: {},
      economicIndicators: {},
      publishedStatus: {},
      channelList: [],
      regionsList: [],
      selectedChannel: 0,
      laoding: false,
      channelName: "",
      author: "Harish",
      craLatestReportDate: "",
      craLastReportDate: "",
      validationDialog: false,
      editing: {
        earlyMarket: false,
        previousSession: false,
        marketOverview: false,
        outsideMarkets: false,
        weather: false,
      },
      getError: false,
      isPublished: false,
      showRePublishModal: false,
      marketReportPublished: false,
      showMarketReportPublishModal: false,
    };
    this.diff_date = 0;
    this.divElement = React.createRef();
    this.getSectionData = this.getSectionData.bind(this);
    this.updateImagePath = this.updateImagePath.bind(this);
    this.setPublish = this.setPublish.bind(this);
    this.revertPublish = this.revertPublish.bind(this);
    this.saveSyndicationData = this.saveSyndicationData.bind(this);
    this.getChannelList = this.getChannelList.bind(this);
    this.getRegionList = this.getRegionList.bind(this);
    this.handleChannelChange = this.handleChannelChange.bind(this);
    this.getContentBasedonDateAndRegion = this.getContentBasedonDateAndRegion.bind(this);
    this.setEditing = this.setEditing.bind(this);
    this.updateSectionId = this.updateSectionId.bind(this);
    this.handlePublish = this.handlePublish.bind(this);
    this.handleRepublishModal = this.handleRepublishModal.bind(this);
  }

  updateSectionId(section, id) {
    this.setState((prevState) => ({
      [section]: {
        ...prevState[section],
        id: id,
      },
    }));
  }
  setEditing(sectionBeignEdited, isSectionEdited, isResest) {
    if (isResest) {
      this.setState({
        editing: {
          earlyMarket: false,
          previousSession: false,
          marketOverview: false,
          outsideMarkets: false,
          weather: false,
        },
      });
    } else {
      this.setState((prevState) => ({
        editing: {
          ...prevState.editing,
          [sectionBeignEdited]: isSectionEdited,
        },
      }));
    }
  }
  getChannelName(id) {
    for (var i = 0; i < this.state.channelList.length; i++) {
      if (this.state.channelList[i].value === id) {
        return this.state.channelList[i].label;
      }
    }
    return "";
  }

  getChannelList() {
    return service.getChannels();
  }

  getRegionList() {
    return __service.getSyndicationRegions();
  }

  handleChannelChange(event) {
    this.setState({ channels: event.target.value }, this.saveSyndicationData());
  }

  componentDidMount() {
    try {
      Promise.all([this.getChannelList(), this.getRegionList()]).then((resp) => {
        let [channels, regions] = resp;
        const { isEdibleOilsRole, isAnimalFeedRole, isGrainsRole, isCocoaRole, isSuperAdminRole, isCornRole } =
          this.props;
        let respData = isSuperAdminRole
          ? channels.data
          : channels.data.filter((channel) => {
              return (
                (channel.channelName === BUSINESS_UNIT.EDIBLE_OILS && isEdibleOilsRole) ||
                (channel.channelName === BUSINESS_UNIT.ANIMAL_FEED && isAnimalFeedRole) ||
                (channel.channelName === BUSINESS_UNIT.GRAINS && isGrainsRole) ||
                (channel.channelName === BUSINESS_UNIT.COCOA && isCocoaRole) ||
                (channel.channelName === BUSINESS_UNIT.CORN && isCornRole)
              );
            });
        var list = [];
        for (let i = 0; i < respData.length; i++) {
          list.push({ label: respData[i].channelName, value: respData[i].channelId });
        }
        this.setState(
          {
            channelList: list,
            selectedChannel: list[0].value,
            channelName: list[0].label,
            regionsList: regions.data,
          },
          () => {
            this.onDateOrRegionChange();
          }
        );
      });
    } catch (error) {
      console.log("🚀 ~ Syndication ~ componentDidMount ~ error:", error);
    }
  }

  componentDidUpdate() {
    this.diff_date = moment(this.state.selectedDate).startOf("day").diff(moment().startOf("day"));
  }

  getRegionName(region) {
    let regionName = "";
    switch (region) {
      case REGIONS.NA:
        regionName = REGION_LABELS.North_America;
        break;
      case REGIONS.EMEA:
        regionName = REGIONS.EMEA;
        break;
      case REGIONS.SA:
        regionName = REGION_LABELS.South_America;
        break;
      case REGIONS.SA_PG:
        regionName = REGION_LABELS.South_America_PG;
        break;
      case REGIONS.SA_ES:
        regionName = REGION_LABELS.South_America_ES;
        break;
      case REGIONS.NA_MX_ES:
        regionName = REGION_LABELS.NA_MX_ES;
        break;
      default:
        break;
    }
    return regionName;
  }

  getSectionData(section) {
    switch (section.title.toLocaleLowerCase()) {
      case SECTIONS_TITLE.EARLY_MARKETS.toLocaleLowerCase():
        this.setState({ earlyMarket: section });
        break;
      case SECTIONS_TITLE.PREVIOUS_SESSION.toLocaleLowerCase():
        this.setState({ previous: section });
        break;
      case SECTIONS_TITLE.MARKET_OVERVIEW.toLocaleLowerCase():
        this.setState({ marketOverview: section });
        break;
      case SECTIONS_TITLE.ADVERTISEMENT.toLocaleLowerCase():
        this.setState({ syndicationAdvertisementBanner: section });
        break;
      case SECTIONS_TITLE.OUTSIDE_MARKET.toLocaleLowerCase():
        this.setState({ outsideMarkets: section });
        break;
      case SECTIONS_TITLE.WEATHER.toLocaleLowerCase():
        this.setState({ weather: section });
        break;
      case SECTIONS_TITLE.ECONOMIC_INDICATORS.toLocaleLowerCase():
        this.setState({ economicIndicators: section });
        break;
      default:
        break;
    }
  }

  formatDatetoPush(date) {
    return moment(date).format("YYYY-MM-DD");
  }

  updateImagePath(section, imagePath, ind) {
    switch (section.title.toLocaleLowerCase()) {
      case SECTIONS_TITLE.EARLY_MARKETS.toLocaleLowerCase():
        this.setState(
          (prevState) => {
            if (parseInt(ind) === 0) {
              return { earlyMarket: { ...prevState.earlyMarket, imagePath: imagePath } };
            }
            return { earlyMarket: { ...prevState.earlyMarket, imagePath2: imagePath } };
          },
          () => {
            // this.saveSyndicationData(section.title.toLocaleLowerCase())
          }
        );
        break;
      case SECTIONS_TITLE.PREVIOUS_SESSION.toLocaleLowerCase():
        this.setState(
          (prevState) => ({
            previous: { ...prevState.previous, imagePath: imagePath },
          }),
          () => {
            // this.saveSyndicationData(section.title.toLocaleLowerCase())
          }
        );
        break;
      case SECTIONS_TITLE.ADVERTISEMENT.toLocaleLowerCase():
        this.setState(
          (prevState) => ({
            syndicationAdvertisementBanner: {
              ...prevState.syndicationAdvertisementBanner,
              imagePath: imagePath.imageURL ?? "",
              redirectUrl: imagePath.redirectURL ?? "",
            },
          }),
          () => {
            // this.saveSyndicationData(section.title.toLocaleLowerCase())
          }
        );
        break;
      case SECTIONS_TITLE.ECONOMIC_INDICATORS.toLocaleLowerCase():
        this.setState(
          (prevState) => ({
            economicIndicators: {
              ...prevState.economicIndicators,
              imagePath: imagePath,
            },
          }),
          () => {
            // this.saveSyndicationData(section.title.toLocaleLowerCase())
          }
        );
        break;
      case SECTIONS_TITLE.WEATHER.toLocaleLowerCase():
        this.setState(
          (prevState) => {
            if ("precipitationImage" in prevState.weather && "temperatureImage" in prevState.weather) {
              if (parseInt(ind) === 1) {
                return { weather: { ...prevState.weather, precipitationImage: imagePath } };
              }
              return { weather: { ...prevState.weather, temperatureImage: imagePath } };
            }
            return { weather: { ...prevState.weather, [`image${ind}`]: imagePath } };
          },
          () => {
            // this.saveSyndicationData(section.title.toLocaleLowerCase())
          }
        );
        break;
      default:
        break;
    }
  }

  getContentBasedonDateAndRegion(region, sectionTitle, currentOrPrevious, section, func, subTitle) {
    let date = this.state.selectedDate;
    let requestDate = currentOrPrevious === "current" ? date : moment(date).subtract(1, "day").format("YYYY-MM-DD");
    requestDate = this.formatDatetoPush(requestDate);
    let selectedRegion = this.state.regionsList.find(
      (reg) => reg.region.toLocaleLowerCase() === region.toLocaleLowerCase()
    );

    __service
      .getSyndication(requestDate, selectedRegion.regionId, this.state.selectedChannel)
      .then((response) => {
        response = response.data;
        let val = "";
        let title = sectionTitle.toLocaleLowerCase();
        if (title === SECTIONS_TITLE.OUTSIDE_MARKET.toLocaleLowerCase()) {
          val = response.outsideMarketDTO.content;
        } else if (title === SECTIONS_TITLE.PREVIOUS_SESSION.toLocaleLowerCase()) {
          val = response.previousDTO.content;
        } else if (title === SECTIONS_TITLE.WEATHER.toLocaleLowerCase()) {
          val = response?.weatherDTO?.content;
        } else if (title === SECTIONS_TITLE.MARKET_OVERVIEW.toLocaleLowerCase()) {
          var list = response.marketOverviewReportDTO.marketOverviewDetailDTOS;
          for (var i = 0; i < list.length; i++) {
            if (list[i].title === subTitle) val = list[i].content;
          }
        }
        if (val === "" || val === undefined) {
          this.toast.show({
            severity: "info",
            summary: "Empty",
            detail: "This section was empty on selected date and region",
            life: 3000,
          });
          return;
        }
        section.content = val;
        func(section);
      })
      .catch((error) => {
        console.error(error);
        this.toast.show({
          severity: "error",
          summary: "Error",
          detail: "Error while fetching details from selected region and date",
          life: 5000,
        });
      });
  }

  saveSyndicationData(reportSection) {
    let pushData = this.getPublishData();
    service.saveSyndicationContent(pushData).then((response) => {});
  }

  formatHTMLforPublish(clonnedWrapper) {
    let div = clonnedWrapper;

    let elements = div.getElementsByClassName("editContent");
    while (elements[0]) elements[0].parentNode.removeChild(elements[0]);
    elements = div.getElementsByClassName("add_link_verbiage");
    while (elements[0]) elements[0].parentNode.removeChild(elements[0]);
    elements = div.getElementsByClassName("RemoveImage");
    while (elements[0]) elements[0].parentNode.removeChild(elements[0]);
    elements = div.getElementsByClassName("generateImage");
    while (elements[0]) elements[0].parentNode.removeChild(elements[0]);
    elements = div.getElementsByClassName("savesectionbtn");
    while (elements[0]) elements[0].parentNode.removeChild(elements[0]);
    elements = div.getElementsByClassName("msg__container");
    while (elements[0]) elements[0].parentNode.removeChild(elements[0]);
    elements = div.getElementsByClassName("msg__content");
    while (elements[0]) elements[0].parentNode.removeChild(elements[0]);
    if (
      this.state.channelName === BUSINESS_UNIT.EDIBLE_OILS &&
      this.state.region === REGIONS.SA &&
      this.state.economicIndicators.imagePath === ""
    ) {
      elements = div.getElementsByClassName("sa_ecnomic_indicator");
      while (elements[0]) elements[0].parentNode.removeChild(elements[0]);
    }
    elements = div.getElementsByClassName("syndication__section__wrapper");
    while (elements[0]) elements[0].replaceWith(...elements[0].children);

    let htmlContent = div.innerHTML;
    let x = '<span style="font-size: 16px; color: grey;">Edit Content</span>';
    let n = htmlContent.search(x);
    while (n > 0) {
      htmlContent = htmlContent.substring(0, n) + htmlContent.substring(n + x.length, htmlContent.length);
      n = htmlContent.search(x);
    }
    htmlContent = htmlContent.replace(/(?:\r\n|\r|\n)/g, "<br>"); // This is to enable line breaks in paragraph for emails
    htmlContent = htmlContent.replace(/white-space: pre-line/g, ""); // This is to ensure the layout remains same in mobile devices
    return htmlContent;
  }

  setPublish() {
    this.setState({ publish: true, showRePublishModal: false, showMarketReportPublishModal: false });

    let htmlContent = this.formatHTMLforPublish(this.divEle.cloneNode(true));
    let selectedRegion = this.state.regionsList.find(
      (reg) => reg.region.toLocaleLowerCase() === this.state.region.toLocaleLowerCase()
    );
    let regionId = selectedRegion ? selectedRegion.regionId : -1;
    let publishEmailData = {
      channelId: this.state.selectedChannel,
      regionId: regionId,
      reportDate: this.formatDateForAPI(this.state.reportDate),
      emailContent: htmlContent,
    };
    service
      .pushTemplate(publishEmailData)
      .then((response) => {
        if (response.data.status === "success") {
          this.toast.show({
            severity: "success",
            summary: "Success",
            detail: "Market commentary is sent to SFMC successfully",
            life: 5000,
          });
          this.setState({
            isPublished: true,
          });
        } else {
          this.toast.show({
            severity: "error",
            summary: "Error",
            detail: "Error while sending syndication data to SFMC",
            life: 5000,
          });
        }
      })
      .catch((error) => {
        console.error(error);
        this.toast.show({
          severity: "error",
          summary: "Error",
          detail: "Error while sending syndication data to SFMC",
          life: 5000,
        });
      });
  }

  publishSyndicationContent() {
    const publishData = this.getPublishData();
    const region = publishData.region;
    const productLineId = publishData.productLineId;
    const __isEarlyMarketEmpty = isEarlyMarketEmpty(publishData.earlyMarket);
    const __isPreviousEmpty = isPreviousEmpty(publishData.previous, productLineId);
    const __isMarketOverviewEmpty = isMarketOverviewEmpty(publishData.marketOverview);
    const __isOutSideMarketEmpty = isOutSideMarketEmpty(publishData.outsideMarkets);
    const __isWeatherEmpty = isWeatherEmpty(region, publishData.weather);
    this.setState({
      prePublish: true,
      showMarketReportPublishModal: false,
    });
    if (
      !__isEarlyMarketEmpty &&
      !__isPreviousEmpty &&
      !__isMarketOverviewEmpty &&
      !__isOutSideMarketEmpty &&
      !__isWeatherEmpty &&
      !this.state.editing.earlyMarket &&
      !this.state.editing.previousSession &&
      !this.state.editing.marketOverview &&
      !this.state.editing.outsideMarkets &&
      !this.state.editing.weather
    ) {
      this.setState({
        prePublish: false,
      });
      if (!this.state.isPublished) {
        this.setState({
          showMarketReportPublishModal: true,
        });
      }
    } else {
      this.setState({
        validationDialog: true,
      });
    }
  }

  handlePublish() {
    if (this.state.isPublished) {
      this.setState({
        showRePublishModal: true,
      });
    } else {
      this.publishSyndicationContent();
    }
  }

  handleRepublishModal(proceedToPublish = false) {
    if (proceedToPublish) this.publishSyndicationContent();
    else {
      this.setState({
        showRePublishModal: false,
      });
    }
  }

  formatDateForAPI(date) {
    return moment(date).format("YYYY-MM-DD");
  }

  processWeather(weather) {
    let { title, content, editFlag } = { ...weather };
    let imageA = { imagePath: weather.imageAPath, title: "Precipitation" };
    let imageB = { imagePath: weather.imageBPath, title: "Temperature" };
    return { title, content, imageA, imageB, editFlag };
  }

  formatWeather(weather) {
    let { title, content } = { ...weather };
    let imageAPath = weather.imageA.imagePath;
    let imageBPath = weather.imageB.imagePath;
    return {
      title,
      content,
      imageAPath,
      imageBPath,
    };
  }

  async onDateOrRegionChange() {
    this.setState((prevState) => ({ ...prevState, loading: true, getError: false }));

    let publishDate = this.formatDateForAPI(this.state.selectedDate);
    let region = this.state.region;
    let selectedRegion = this.state.regionsList.find(
      (reg) => reg.region.toLocaleLowerCase() === region.toLocaleLowerCase()
    );
    if (
      publishDate === "" ||
      selectedRegion === undefined ||
      selectedRegion === null ||
      this.state.selectedChannel === null ||
      this.state.selectedChannel === undefined
    ) {
      return;
    }
    try {
      let newSyndicationContent = await __service.getSyndication(
        publishDate,
        selectedRegion.regionId,
        this.state.selectedChannel
      );
      this.setState({ marketReportPublished: newSyndicationContent.isPublished });
      let publishStatus = false;
      let {
        earlyMarketReportDTO,
        previousDTO,
        marketOverviewReportDTO,
        outsideMarketDTO,
        advertisementBannerDTO,
        economicIndicatorDTO,
        weatherDTO,
        cocoaSAWeatherDTO,
        craLatestReportDate,
        craLastReportDate,
        masterDetails,
        productLineId,
        selectedDate,
        region,
        isPublished,
      } = { ...newSyndicationContent.data };
      this.setState({
        publish: publishStatus,
        earlyMarket: {
          regionId: earlyMarketReportDTO.regionId,
          reportDate: earlyMarketReportDTO.reportDate,
          productLineId: earlyMarketReportDTO.productLineId,
          ...earlyMarketReportDTO.earlyMarketDTO,
          syndicationCommodities: earlyMarketReportDTO.earlyMarketCommodityDTOS,
        },
        marketOverview: {
          regionId: marketOverviewReportDTO.regionId,
          reportDate: marketOverviewReportDTO.reportDate,
          productLineId: marketOverviewReportDTO.productLineId,
          ...marketOverviewReportDTO.marketOverviewDTO,
          marketOverviewSections: marketOverviewReportDTO.marketOverviewDetailDTOS,
        },
        outsideMarkets: outsideMarketDTO,
        previous: previousDTO,
        syndicationAdvertisementBanner: advertisementBannerDTO,
        economicIndicators: { ...economicIndicatorDTO, title: "Economic Indicators" },
        weather: weatherDTO || cocoaSAWeatherDTO,
        loading: false,
        getError: false,
        craLatestReportDate: craLatestReportDate,
        craLastReportDate: craLastReportDate,
        publishedStatus: masterDetails,
        selectedChannel: productLineId,
        reportDate: selectedDate,
        region: region,
        isPublished: isPublished,
      });
    } catch (err) {
      console.error(err);
      this.setState({ loading: false, getError: true });
    }
  }

  getPublishData() {
    let returnObj = {
      publishedStatus: this.state.publishedStatus,
      region: this.state.region,
      productLineId: this.state.selectedChannel,
      reportDate: this.formatDateForAPI(this.state.selectedDate),
      earlyMarket: this.state.earlyMarket,
      previous: this.state.previous,
      marketOverview: this.state.marketOverview,
      outsideMarkets: this.state.outsideMarkets,
      syndicationAdvertisementBanner: this.state.syndicationAdvertisementBanner,
      defaultContent: false,
    };
    if (this.state.region === REGIONS.SA) {
      returnObj.economicIndicators = this.state.economicIndicators;
    } else {
      returnObj.weather = this.state.weather;
    }
    return returnObj;
  }

  revertPublish() {
    this.setState({ publish: false });
  }

  render() {
    const oilsRegionItems = [
      { label: REGION_LABELS.North_America, value: REGIONS.NA },
      { label: REGIONS.EMEA, value: REGIONS.EMEA },
      { label: REGION_LABELS.South_America, value: REGIONS.SA },
      { label: REGION_LABELS.NA_MX_ES, value: REGIONS.NA_MX_ES },
    ];

    const defaultRegionItems = [{ label: REGIONS.EMEA, value: REGIONS.EMEA }];
    const cocoRegionItems = [
      { label: REGIONS.EMEA, value: REGIONS.EMEA },
      { label: REGION_LABELS.South_America_PG, value: REGIONS.SA_PG },
      { label: REGION_LABELS.South_America_ES, value: REGIONS.SA_ES },
      { label: REGION_LABELS.North_America, value: REGIONS.NA },
    ];
    const cornRegionItems = [{ label: REGIONS.NA, value: REGIONS.NA }];
    let publishData = this.getPublishData();
    let productLineId = publishData.productLineId;
    let region = publishData.region;
    let selectedRegion = this.state.regionsList.find(
      (reg) => reg.region.toLocaleLowerCase() === region.toLocaleLowerCase()
    );
    let regionId = selectedRegion ? selectedRegion.regionId : -1;
    let __isEarlyMarketEmpty = isEarlyMarketEmpty(publishData.earlyMarket);
    let __isPreviousEmpty = isPreviousEmpty(publishData.previous, productLineId);
    let __isMarketOverviewEmpty = isMarketOverviewEmpty(publishData.marketOverview);
    let __isOutSideMarketEmpty = isOutSideMarketEmpty(publishData.outsideMarkets);
    let __isWeatherEmpty = isWeatherEmpty(region, publishData.weather);
    return (
      <div className='syndication-box'>
        {/* <Navbar /> */}
        <Toast ref={(el) => (this.toast = el)} baseZIndex={20000} />
        <div style={{ paddingTop: "90px", position: "absolute", right: "125px" }}>
          <div className='p-fluid formgrid '>
            <div className='field'>
              <label className='label'>Date</label>
              <Calendar
                showIcon={true}
                dateFormat='MM d, yy'
                icon='pi pi-calendar'
                viewDate={this.state.selectedDate}
                value={this.state.selectedDate}
                onChange={(e) => {
                  this.setState({ selectedDate: e.value, prePublish: false }, this.onDateOrRegionChange);
                }}
                showOtherMonths={false}
                pt={{
                  monthTitle: { style: { color: "#CCC" } },
                  yearTitle: { style: { color: "#CCC" } },
                }}
              ></Calendar>
            </div>
            <div className='field'>
              <label className='label'>Channel / Product Line</label>
              {this.state.channelList?.length > 0 && (
                <Dropdown
                  name='channels'
                  value={this.state.selectedChannel}
                  options={this.state.channelList}
                  onChange={(e) => {
                    const selectedChannel = this.state.channelList.find((item) => item.value === e.value);
                    const isCorn = selectedChannel.label.toLowerCase() === BUSINESS_UNIT.CORN.toLowerCase();
                    const selectedRegion = isCorn ? REGIONS.NA : REGIONS.EMEA;
                    this.setState(
                      {
                        selectedChannel: e.target.value,
                        region: selectedRegion,
                        channelName: this.getChannelName(e.target.value),
                      },
                      this.onDateOrRegionChange
                    );
                  }}
                />
              )}
            </div>
            <div className='field'>
              <label className='label'>Region</label>
              <Dropdown
                value={this.state.region}
                // options={oilsRegionItems}
                options={
                  this.state.channelName === BUSINESS_UNIT.EDIBLE_OILS
                    ? oilsRegionItems
                    : this.state.channelName === BUSINESS_UNIT.COCOA
                      ? cocoRegionItems
                      : this.state.channelName === BUSINESS_UNIT.CORN
                        ? cornRegionItems
                        : defaultRegionItems
                }
                onChange={(e) => {
                  this.setState({ region: e.value, prePublish: false }, this.onDateOrRegionChange);
                }}
              />
            </div>
          </div>
          <div>
            {!this.state.publish && this.diff_date === 0 ? (
              <>
                <Button
                  className='p-button-sm btn3'
                  label='Publish'
                  icon='pi pi-check'
                  iconPos='right'
                  onClick={this.handlePublish}
                />
                <Dialog
                  header='Syndication Validation'
                  id='mi__syndication__dialog'
                  baseZIndex={10001}
                  visible={this.state.validationDialog}
                  modal
                  style={{ width: "350px" }}
                  footer={
                    <Button
                      label='Okay'
                      icon='pi pi-check'
                      onClick={() => {
                        this.setState({
                          validationDialog: false,
                        });
                      }}
                      className='p-button-text'
                    />
                  }
                  onHide={() =>
                    this.setState({
                      validationDialog: false,
                    })
                  }
                >
                  <div className='flex flex-column' style={{ color: "#FFF" }}>
                    <div className='flex align-items-center'>
                      <i className='pi pi-exclamation-triangle mr-3' style={{ fontSize: "2rem" }} />
                      <span>Please fill/save the following sections before publishing</span>
                    </div>
                    <ul>
                      {__isEarlyMarketEmpty || this.state.editing.earlyMarket ? (
                        <li>{productLineId === 3 ? "Overview of Grain Prices" : "Early Markets"}</li>
                      ) : null}
                      {__isPreviousEmpty || this.state.editing.previousSession ? (
                        <li>Previous Session Highlights</li>
                      ) : null}
                      {__isMarketOverviewEmpty || this.state.editing.marketOverview ? <li>Market Overview</li> : null}
                      {__isOutSideMarketEmpty || this.state.editing.outsideMarkets ? <li>Outside Markets</li> : null}
                      {__isWeatherEmpty || this.state.editing.weather ? <li>Weather</li> : null}
                    </ul>
                  </div>
                </Dialog>
              </>
            ) : (
              this.state.publish && (
                <Button
                  className='p-button-sm btn3'
                  label='Edit'
                  icon='pi pi-times'
                  iconPos='right'
                  onClick={this.revertPublish}
                />
              )
            )}
          </div>
        </div>
        <div>
          <div ref={(divEle) => (this.divEle = divEle)} style={{ paddingTop: "90px" }}>
            <SyndicationHeader
              region={this.state.region}
              regionName={this.getRegionName(this.state.region)}
              businessUnit={this.state.channelName}
              selectedDate={this.state.selectedDate}
              headerImgSrc={this.state?.publishedStatus?.headerImage}
            />
            {this.state.getError ? (
              <table width='800' align='center' className='msg__container'>
                <Message
                  className='border-primary w-full justify-content-start'
                  severity='error'
                  content={"Error retrieving Content"}
                />
              </table>
            ) : (
              <>
                {this.state.earlyMarket && (
                  <ConditionalWrapper
                    condition={this.state.prePublish && __isEarlyMarketEmpty}
                    wrapper={(children) => (
                      <div style={{ width: "fit-content", margin: "0 auto", border: "1px solid red" }}>{children}</div>
                    )}
                  >
                    <EarlyMarkets
                      key={this.state.selectedDate}
                      setEditing={this.setEditing}
                      updateSectionId={this.updateSectionId}
                      loading={this.state.loading}
                      publish={this.state.publish}
                      closeDate={this.state.craLatestReportDate}
                      previousCloseDate={this.state.craLastReportDate}
                      businessUnit={this.state.channelName}
                      region={this.state.region}
                      selectedDate={this.state.selectedDate}
                      diff_date={this.diff_date}
                      getSectionData={this.getSectionData}
                      section={this.state.earlyMarket}
                      productLineId={productLineId}
                      regionId={regionId}
                      reportDate={this.formatDateForAPI(this.state.selectedDate)}
                      updateImagePath={this.updateImagePath}
                      getContentBasedonDateAndRegion={this.getContentBasedonDateAndRegion}
                    />
                  </ConditionalWrapper>
                )}

                {this.state.previous && (
                  <ConditionalWrapper
                    condition={productLineId !== 3 && this.state.prePublish && __isPreviousEmpty}
                    wrapper={(children) => (
                      <div style={{ width: "fit-content", margin: "0 auto", border: "1px solid red" }}>{children}</div>
                    )}
                  >
                    <PreviousSession
                      key={this.state.selectedDate}
                      setEditing={this.setEditing}
                      updateSectionId={this.updateSectionId}
                      loading={this.state.loading}
                      productLineId={productLineId}
                      regionId={regionId}
                      reportDate={this.formatDateForAPI(this.state.selectedDate)}
                      publish={this.state.publish}
                      businessUnit={this.state.channelName}
                      closeDate={this.state.craLatestReportDate}
                      previousCloseDate={this.state.craLastReportDate}
                      regions={
                        this.state.channelName === BUSINESS_UNIT.EDIBLE_OILS
                          ? oilsRegionItems
                          : this.state.channelName === BUSINESS_UNIT.CORN
                            ? cornRegionItems
                            : defaultRegionItems
                      }
                      region={this.state.region}
                      selectedDate={this.state.selectedDate}
                      diff_date={this.diff_date}
                      getSectionData={this.getSectionData}
                      section={this.state.previous}
                      updateImagePath={this.updateImagePath}
                      getContentBasedonDateAndRegion={this.getContentBasedonDateAndRegion}
                    />
                  </ConditionalWrapper>
                )}
                {this.state.marketOverview && (
                  <ConditionalWrapper
                    condition={this.state.prePublish && __isMarketOverviewEmpty}
                    wrapper={(children) => (
                      <div style={{ width: "fit-content", margin: "0 auto", border: "1px solid red" }}>{children}</div>
                    )}
                  >
                    <MarketOverview
                      setEditing={this.setEditing}
                      updateSectionId={this.updateSectionId}
                      loading={this.state.loading}
                      publish={this.state.publish}
                      businessUnit={this.state.channelName}
                      regions={
                        this.state.channelName === BUSINESS_UNIT.EDIBLE_OILS
                          ? oilsRegionItems
                          : this.state.channelName === BUSINESS_UNIT.CORN
                            ? cornRegionItems
                            : defaultRegionItems
                      }
                      region={this.state.region}
                      selectedDate={this.state.selectedDate}
                      diff_date={this.diff_date}
                      channel={{ label: this.state.channelName, value: this.state.selectedChannel }}
                      getSectionData={this.getSectionData}
                      section={this.state.marketOverview}
                      productLineId={productLineId}
                      regionId={regionId}
                      reportDate={this.formatDateForAPI(this.state.selectedDate)}
                      getContentBasedonDateAndRegion={this.getContentBasedonDateAndRegion}
                    />
                  </ConditionalWrapper>
                )}
                {this.state.syndicationAdvertisementBanner && (
                  <AdvertisementBanner
                    // setEditing={this.setEditing}
                    updateSectionId={this.updateSectionId}
                    loading={this.state.loading}
                    publish={this.state.publish}
                    region={this.state.region}
                    selectedDate={this.state.selectedDate}
                    diff_date={this.diff_date}
                    getSectionData={this.getSectionData}
                    section={this.state.syndicationAdvertisementBanner}
                    productLineId={productLineId}
                    regionId={regionId}
                    reportDate={this.formatDateForAPI(this.state.selectedDate)}
                    updateImagePath={this.updateImagePath}
                  />
                )}
                {this.state.outsideMarkets && (
                  <ConditionalWrapper
                    condition={this.state.prePublish && __isOutSideMarketEmpty}
                    wrapper={(children) => (
                      <div style={{ width: "fit-content", margin: "0 auto", border: "1px solid red" }}>{children}</div>
                    )}
                  >
                    <OutsideMarkets
                      setEditing={this.setEditing}
                      updateSectionId={this.updateSectionId}
                      loading={this.state.loading}
                      publish={this.state.publish}
                      businessUnit={this.state.channelName}
                      regions={
                        this.state.channelName === BUSINESS_UNIT.EDIBLE_OILS
                          ? oilsRegionItems
                          : this.state.channelName === BUSINESS_UNIT.CORN
                            ? cornRegionItems
                            : defaultRegionItems
                      }
                      region={this.state.region}
                      selectedDate={this.state.selectedDate}
                      diff_date={this.diff_date}
                      getSectionData={this.getSectionData}
                      section={this.state.outsideMarkets}
                      productLineId={productLineId}
                      regionId={regionId}
                      reportDate={this.formatDateForAPI(this.state.selectedDate)}
                      getContentBasedonDateAndRegion={this.getContentBasedonDateAndRegion}
                    />
                  </ConditionalWrapper>
                )}
                {this.state.region === REGIONS.SA && this.state.economicIndicators && (
                  <EconomicIndicators
                    setEditing={this.setEditing}
                    updateSectionId={this.updateSectionId}
                    loading={this.state.loading}
                    publish={this.state.publish}
                    region={this.state.region}
                    selectedDate={this.state.selectedDate}
                    diff_date={this.diff_date}
                    getSectionData={this.getSectionData}
                    section={this.state.economicIndicators}
                    productLineId={productLineId}
                    regionId={regionId}
                    reportDate={this.formatDateForAPI(this.state.selectedDate)}
                    updateImagePath={this.updateImagePath}
                  />
                )}
                {this.state.region !== REGIONS.SA && this.state.weather && (
                  <ConditionalWrapper
                    condition={this.state.prePublish && __isWeatherEmpty}
                    wrapper={(children) => (
                      <div style={{ width: "fit-content", margin: "0 auto", border: "1px solid red" }}>{children}</div>
                    )}
                  >
                    <Weather
                      setEditing={this.setEditing}
                      updateSectionId={this.updateSectionId}
                      loading={this.state.loading}
                      publish={this.state.publish}
                      businessUnit={this.state.channelName}
                      regions={
                        this.state.channelName === BUSINESS_UNIT.EDIBLE_OILS
                          ? oilsRegionItems
                          : this.state.channelName === BUSINESS_UNIT.CORN
                            ? cornRegionItems
                            : defaultRegionItems
                      }
                      region={this.state.region}
                      selectedDate={this.state.selectedDate}
                      diff_date={this.diff_date}
                      getSectionData={this.getSectionData}
                      section={this.state.weather}
                      productLineId={productLineId}
                      regionId={regionId}
                      reportDate={this.formatDateForAPI(this.state.selectedDate)}
                      getContentBasedonDateAndRegion={this.getContentBasedonDateAndRegion}
                      updateImagePath={this.updateImagePath}
                    />
                  </ConditionalWrapper>
                )}
              </>
            )}
            <Footer businessUnit={this.state.channelName} footerData={this.state.publishedStatus} />
          </div>
          <Dialog
            header='Warning'
            id='republish-dialog'
            baseZIndex={10001}
            visible={this.state.showRePublishModal}
            modal
            style={{ width: "500px" }}
            footer={
              <div className='flex justify-content-end align-items-center'>
                <Button
                  className='p-button-text text-black'
                  label='Cancel'
                  onClick={() => this.handleRepublishModal(false)}
                />
                <Button
                  className='p-button-text text-black'
                  label='Proceed'
                  onClick={() => {
                    this.handleRepublishModal(true);
                    this.setPublish();
                  }}
                />
              </div>
            }
            onHide={() => this.handleRepublishModal(false)}
          >
            <div className='border-t border-b border-gray-700'>
              <h4 className='text-white'>This report has already been published</h4>
              <p className='text-white'>
                If you need to revise content and re-publish you need to clear the previous API record in SFMC to avoid
                multiple reports being sent.
              </p>
            </div>
          </Dialog>

          <Dialog
            header='Warning'
            id='republish-dialog'
            baseZIndex={10001}
            visible={this.state.showMarketReportPublishModal}
            modal
            style={{ width: "500px" }}
            footer={
              <div className='flex justify-content-end align-items-center'>
                <Button
                  className='p-button-text text-black'
                  label='Cancel'
                  onClick={() => {
                    this.setState({
                      showMarketReportPublishModal: false,
                    });
                  }}
                />
                <Button
                  className='p-button-text text-black'
                  label='Proceed'
                  onClick={() => {
                    this.setPublish();
                  }}
                />
              </div>
            }
            onHide={() => {
              this.setState({
                showMarketReportPublishModal: false,
              });
            }}
          >
            <div className='border-t border-b border-gray-700'>
              <h4 className='text-white'>Market Report Submit Confirmation</h4>
              <p className='text-white'>Are you sure you want to publish the report.</p>
            </div>
          </Dialog>
        </div>
      </div>
    );
  }
}
